const Owner = props => (
  <svg {...props} width="26" height="30" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13 15C17.1031 15 20.4286 11.6426 20.4286 7.5C20.4286 3.35742 17.1031 0 13 0C8.89688 0 5.57143 3.35742 5.57143 7.5C5.57143 11.6426 8.89688 15 13 15ZM18.2 16.875H17.2308C15.9424 17.4727 14.5089 17.8125 13 17.8125C11.4911 17.8125 10.0634 17.4727 8.7692 16.875H7.8C3.49375 16.875 0 20.4023 0 24.75V27.1875C0 28.7402 1.24777 30 2.78571 30H23.2143C24.7522 30 26 28.7402 26 27.1875V24.75C26 20.4023 22.5063 16.875 18.2 16.875Z" fill="#262525"/>
  </svg>
)

export default Owner
